export default [
  {"id":"candidate-learn-index","index":true,"component":"LearnHome","guard":"none"},
  {"id":"candidate-learn-course","path":"courses/:courseId","component":"LearnCourse","guard":"none"},
  {"id":"candidate-learn-course-purpose","path":"courses/:courseId/:purposeId","component":"LearnPurposeView","guard":"none"},
  {"id":"candidate-learn-unit","path":"courses/:courseId/units/:unitId","component":"LearnUnit","guard":"none"},
  {"id":"candidate-learn-document","path":"documents/:documentId","component":"LearnDocumentPending","guard":"none"},
  {"id":"candidate-learn-fallback","path":"*","component":"LearnNotFound","guard":"none"}
];
